import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import SelectUser from "@/components/selectUser";
import api from "@/services/api";
import { useParams } from "react-router-dom";

export default function FileView() {
  const { answer_id, file_id } = useParams();
  const [file, setFile] = useState(null);
  const [values, setValues] = useState({ user_id: "", user_name: "", user_avatar: "", comment: "" });

  useEffect(() => {
    getFile();
  }, []);

  async function getFile() {
    try {
      const { ok, data } = await api.get(`/mission_ao_file/${file_id}`);
      if (!ok) throw new Error("Failed to fetch file");
      setFile(data);
      setValues(data);
    } catch (error) {
      console.error(error);
      toast.error("Error fetching file");
    }
  }

  const handleSave = async () => {
    try {
      const { ok } = await api.put(`/mission_ao_file/${file_id}`, values);
      if (!ok) throw new Error("Failed to update file");
      toast.success("File updated successfully!");
    } catch (error) {
      console.error(error);
      toast.error("Error updating");
    }
  };

  if (!file) return null;

  return (
    <div className="p-4">
      <div className="flex gap-4">
        <div className="flex-1 flex flex-col">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Assigned User</label>
              <SelectUser
                value={{ _id: values.user_id, name: values.user_name, avatar: values.user_avatar }}
                onChange={(user) => setValues({ ...values, user_id: user._id, user_name: user.name, user_avatar: user.avatar })}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea
                className="w-full rounded-md border border-gray-300 p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={values.comment}
                onChange={(e) => setValues({ ...values, comment: e.target.value })}
                rows={4}
              />
            </div>
            <div className="flex justify-end">
              <button
                onClick={handleSave}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                Save
              </button>
            </div>
          </div>
        </div>
        <div className="w-1/2">
          <FilePreview file={file} />
        </div>
      </div>
    </div>
  );
}

const FilePreview = ({ file }) => {
  if (!file) return null;

  const extension = file.url.split(".").pop().toLowerCase();

  if (extension === "pdf") {
    return <iframe src={file.url} className="w-full h-[800px] border rounded" title={file.label} />;
  }

  if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
    return <img src={file.url} alt={file.label} className="max-w-full h-auto rounded" />;
  }

  if (["xlsx", "xls", "doc", "docx"].includes(extension)) {
    return <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file.url)}`} className="w-full h-[800px] border rounded" title={file.label} />;
  }

  return (
    <div className="p-4 bg-gray-100 rounded">
      <p>Preview not available for this file type</p>
      <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
        Download file
      </a>
    </div>
  );
};
